module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_12.7c9ed51e.jpg";